import { ContactState, ContactTypes, ContactActionTypes } from './types'
import { Reducer } from 'redux'

const initialState: ContactState = {
  contacts: []
}

type ReducerOpts = Reducer<ContactState, ContactActionTypes>
const reducer: ReducerOpts = (state = initialState, action: ContactActionTypes): ContactState => {
  let index = -1
  switch (action.type) {
    case ContactTypes.CONTACT_CREATE:
      return { ...state, contacts: [...state.contacts, action.payload] }
    case ContactTypes.CONTACT_UPDATE:
      index = state.contacts.findIndex(obj => obj.id === action.payload.id)
      return {
        ...state,
        contacts: [
          ...state.contacts.slice(0, index),
          action.payload,
          ...state.contacts.slice(index + 1)
        ]
      }
    case ContactTypes.CONTACT_DELETE:
      index = state.contacts.findIndex(obj => obj.id === action.payload)
      return {
        ...state,
        contacts: [
          ...state.contacts.slice(0, index),
          ...state.contacts.slice(index + 1)
        ]
      }
    case ContactTypes.CONTACT_GET:
      return { ...state, contact: action.payload }
    case ContactTypes.CONTACT_GET_LIST:
      return { ...state, contacts: action.payload }
    default:
      return state
  }
}

export default reducer
